import React from 'react';
import PropTypes from 'prop-types';

import CustomTable from '../../CoreWrappers/CustomTable';

const CommonContactTable = ({tableConfig}) => {
	let props = {
		...tableConfig
	};

	return <CustomTable {...props} />;
};

//TODO: complete. will have the same shape as CustomTable props.
const tableConfigShape = {};

CommonContactTable.defaultProps = {
	activateProfileModal: false, //will enable or disable the profile modal functionality on the table.
	selectContactPermission: true
};

CommonContactTable.propTypes = {
	tableConfig: PropTypes.shape(tableConfigShape).isRequired,
	activateProfileModal: PropTypes.bool,
	selectContactPermission: PropTypes.bool
};

export default CommonContactTable;
